import React, { useState } from 'react';
import { createGlobalStyle, ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { Normalize } from 'styled-normalize';
import { mergeDeep } from './helpers';
import Tabs from './Tabs';
import defaultTheme from './theme';
import { InternationalPhoneInputStyles } from './form/InternationalPhoneInput';
const GlobalStyle = createGlobalStyle(["*,*::before,*::after{box-sizing:border-box;}html{height:100%;}body{height:100%;margin:0;font-family:", ";font-size:14px;line-height:1.5;color:", ";background-color:", ";}@media (min-width:", "){body{font-size:16px;}}"], defaultTheme.fonts.body, defaultTheme.colors.text, defaultTheme.colors.background, defaultTheme.breakpoints[0]);
const ThemeContext = /*#__PURE__*/React.createContext();
const {
  Provider
} = ThemeContext;
const emptyTheme = {};
const ThemeProvider = _ref => {
  let {
    children,
    theme: themeOverrides = emptyTheme
  } = _ref;
  const [theme] = useState(mergeDeep({}, defaultTheme, themeOverrides));
  return /*#__PURE__*/React.createElement(StyledComponentsThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Provider, {
    value: {
      theme
    }
  }, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Normalize, null), /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(InternationalPhoneInputStyles, null), children)));
};
export default ThemeProvider;
export { ThemeContext };